import { usePhoneVerificationStatusQuery } from "Api/Queries/Auth/usePhoneVerificationStatusQuery";
import { isPhoneEmpty } from "Utils/PhoneUtils";

export const usePhoneVerificationStatus = () => {
  const { data, isLoading } = usePhoneVerificationStatusQuery();

  return {
    isLoading,
    // Server-computed: current phone is non-empty AND equals the OTP-verified one.
    isVerified: data?.isVerified ?? false,
    phone: data?.phone ?? null,
    hasPhone: !isPhoneEmpty(data?.phone),
  };
};
